import React from 'react';

const ConfirmPage = React.lazy(() => import('./ConfirmPage' /* webpackChunkName: "Confirm" */));
const ConfirmPageInitializer = () => <ConfirmPage />;
export default ConfirmPageInitializer;
